import Serializable                       from "@/core/misc/mixins/Serializable";
import Core                               from "@/core/Core";
import Qty                                from "@/core/types/Qty";
import Unit                               from "@/domains/Units/Unit";
import OrderPositionShipmentTrancheRecord from "./OrderPositionShipmentTrancheRecord";

/**
 * Транш отгрузок позиции заказа: связка сборка → отгрузка → приёмка
 * с итоговыми количествами по каждому этапу.
 *
 * Не путать с OrderPositionShipmentStatus: тот — агрегат по всей позиции
 * заказа (лежит в orderPosition.shipmentStatus), а транш — одна цепочка
 * документов, таких цепочек у позиции может быть несколько.
 */
class OrderPositionShipmentTranche extends Serializable {
    /** Собрано по траншу */
    public qtyAssembled: Qty;
    /** Отгружено по траншу */
    public qtyShipped: Qty;
    /** Принято по траншу */
    public qtyReceived: Qty;
    /** Заявленный брак по траншу */
    public qtyComplained: Qty;
    /** Итог транша — наибольшее из собранного, отгруженного и принятого */
    public qtyTotal: Qty;
    /** Единица измерения позиции заказа */
    public unit: Unit;
    /** Документы транша: сначала сборки, затем отгрузки и приёмки */
    public entities: OrderPositionShipmentTrancheRecord[];

    static fromServer(data: any, result = new OrderPositionShipmentTranche()): OrderPositionShipmentTranche {
        super.fromServer(data, result);

        // ---- super кладёт сырые строки — гидрируем в семантические типы ----
        result.qtyAssembled  = Core.utils.hydrate(data.qtyAssembled,  Qty.fromServer)!;
        result.qtyShipped    = Core.utils.hydrate(data.qtyShipped,    Qty.fromServer)!;
        result.qtyReceived   = Core.utils.hydrate(data.qtyReceived,   Qty.fromServer)!;
        result.qtyComplained = Core.utils.hydrate(data.qtyComplained, Qty.fromServer)!;
        result.qtyTotal      = Core.utils.hydrate(data.qtyTotal,      Qty.fromServer)!;

        result.unit     = Core.utils.hydrate(data.unit, Unit.fromServer)!;
        result.entities = Core.utils.hydrateArray(data.entities, OrderPositionShipmentTrancheRecord.fromServer);

        return result;
    }
}

export default OrderPositionShipmentTranche;